import React from 'react';
import Button, { ButtonProps } from '@mui/material/Button';
import ReplyIcon from '@mui/icons-material/Reply';
import { useAppDispatch } from 'redux/hooks/reduxHooks';
import { openShareModal } from 'redux/slices/modals/modals.slice';
import { ShareModal } from 'components/Modals/ShareModal/ShareModal';

interface ButtonShareProps extends ButtonProps {
  shareUrl?: string;
  title?: string;
}

export const ButtonShare: React.FC<ButtonShareProps> = ({
  shareUrl = window.location.href,
  title = '',
  ...props
}) => {
  const dispatch = useAppDispatch();

  const handleOpenShareModal = () => {
    dispatch(openShareModal({ url: shareUrl, title }));
  };

  return (
    <>
      <Button
        className="button-share"
        variant="defaultLight"
        sx={{
          minWidth: '102px',
          position: 'relative',
        }}
        onClick={handleOpenShareModal}
        {...props}
      >
        Share
        <ReplyIcon
          sx={{
            transform: 'rotateY(180deg)',
          }}
        />
      </Button>
      <ShareModal />
    </>
  );
};
